import { LoadingButton } from "@mui/lab";
import { Alert, Stack } from "@mui/material";
import { useContext, useState } from "react";
import { ProjectDetailDto, ProjectDto, ProjectService } from "../../../api/psc";
import {
    CardInformation,
    DialogContainer,
    DialogHeader,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";

export default function BatchUpdateProjectVisibilityDialog(props: {
    projects: ProjectDto[] | ProjectDetailDto[];
    onApplied: () => void;
}) {
    const { closeDialog } = useContext(DialogContext);

    const [requestInProgress, setRequestInProgress] = useState(false);

    const updateVisibility = () => {
        setRequestInProgress(true);
        ProjectService.batchUpdateProjectVisibility("1", {
            hide: true,
            folderIdsHash: props.projects.map((p) => p.hashId),
        }).then((r) => {
            setRequestInProgress(false);
            closeDialog();
            props.onApplied();
        });
    };

    return (
        <DialogContainer>
            <DialogHeader title="حذف پروژه های انتخاب شده" />

            <Stack sx={{ p: 2 }} spacing={2}>
                <Alert severity="warning">
                    پروژه های انتخاب شده از لیست شما حذف خواهند شد، در صورت
                    تمایل به مشاهده مجدد میتوانید در فیلتر پروژه های گزینه
                    "نمایش پروژه های حذف شده" را فعال کنید.
                </Alert>

                <CardInformation
                    title="تعداد پروژه های انتحاب شده"
                    value={props.projects.length}
                />

                <LoadingButton
                    fullWidth
                    color="warning"
                    loading={requestInProgress}
                    onClick={updateVisibility}
                    variant="contained"
                >
                    عدم نمایش پروژه های انتخاب شده
                </LoadingButton>
            </Stack>
        </DialogContainer>
    );
}
